import styled from '@emotion/styled';
import LoadingButton from '@mui/lab/LoadingButton';

export const Button = styled(LoadingButton)``;
